import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './PalletTransactions.frontend.types'

@Injectable({ providedIn: 'root' })
export class PalletTransactions_pallet_transaction_create_or_updateService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { remove?: boolean, id?: number, pallet_class_id?: number, project_id?: number, shipment_id?: number, account_id?: number, carrier_id?: number, notes?: string, reference?: string, amount?: number, date?: string }): Promise<{ success?: boolean, exceptions?: string, id?: number }> 
  {
    let url = `${environment.backendUrl}api/PalletTransactions/functions/pallet_transaction_create_or_update`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

